import { FederatedApplications, Preferences, Profile, Resource, User as UserDetails, UserStatuses } from 'ngx-global-nav';

export class User implements UserDetails {

  user_id: string;
  user_type: string;
  user_class: string;
  profile: Profile;
  preferences: Preferences;
  resources: Resource[];
  title: string;
  user_status: UserStatuses;
  ecrm_id?: number;
  federated_applications?: FederatedApplications[];
  brand: string;

  constructor(
    public userDetails: UserDetails,
    public userId: string = '',
    public username: string = (new Date()).toISOString(),
    public userType?: string,
    public userClass?: string,
  ) {
    Object.assign(this, userDetails);

    let names = this.profile.names;
    if(!names.first_name) {
      const locales = Object.keys(names);
      names = names[locales[0]];
    }

    this.profile.names = names;

  }


}
